import React, { useState, useEffect } from "react";
import { ScrollView, KeyboardAvoidingView } from "react-native";

import { find } from "lodash";

import Utils, {
  hasItems,
  getStateData,
  escapeRegexp,
  getActivityModel,
  getTagModel,
  isWeb,
} from "../../../../helpers/utils";

import Search from "../../common/search-bar/Search";
import ActivitiesList from "../../activities/ActivitiesList/ActivitiesList";
import AppConfig from "../../../../config/AppConfig";
import LoadingIndicator from "../../common/LoadingIndicator";
import TagsList from "../../tags/TagsList/TagsList";
import TutorialsHelper from "../../tutorials/TutorialsHelper";
import appStyles from "../../../appStyles";

import ElementsFabButton from "./ElementsFabButton";

import TUTORIALS_DATA from "../../tutorials/data";
import LastWeekHeader from "./LastWeekHeader";

export default function LastWeekElements({
  controller,
  currentActivities,
  goBack,
  showAllActivities = false,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [allActivities, setAllActivities] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState(new Set());
  const [mariMessage, setMariMessage] = useState("");
  const [showTutorials, setShowTutorials] = useState(false);

  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const [allSets, setAllSets] = useState([]);
  //const [visibleSets, setVisibleSets] = useState([]);
  const [selectedSets, setSelectedSets] = useState([]);

  useEffect(() => {
    const setsList = getStateData(controller.state, "sets");
    //const filteredTags = getStateData(controller.state, "tags", [], "name");

    let activitiesList = getStateData(controller.state, "activities");
    if (hasItems(currentActivities)) {
      activitiesList = initActivities(activitiesList);
    }

    setAllActivities(activitiesList);
    setActivities(activitiesList);
    setAllSets(setsList);
    //setVisibleSets(setsList);
    //setAllTags(filteredTags);
    setIsLoading(false);

    initTutorials();
  }, []);

  const initActivities = (activitiesList) => {
    let selectedList = new Set();

    activitiesList.forEach((a) => {
      a.is_selected = false;
      const found = find(
        currentActivities,
        (ca) => a.id == ca.id_activity.replace("_misc", ""),
      );
      if (found) {
        a.is_selected = true;
        a.hours = found.hours;
        a.total_hours = found.total_hours;
        a.is_modified = found.is_modified;
        a.dayIndex = found.dayIndex;
        selectedList.add(a);
      }
    });

    setSelectedActivities(selectedList);

    activitiesList.sort((a, b) => {
      if (a.is_selected == b.is_selected) {
        if (a.is_favorite == b.is_favorite) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        }
        return a.is_favorite < b.is_favorite ? 1 : -1;
      }

      return a.is_selected > b.is_selected ? -1 : 1;
    });

    return activitiesList;
  };

  // ------------------------------------- FILTER -------------------------------------
  // TODO: move duplicate code to helper
  const filterResults = (filters) => {
    const {
      term = null,
      showActivities = true,
      showTags = true,
      showFavorites = true,
      showArchived = false,
      sets = [],
    } = filters != null ? filters : {};
    let filteredActivities = showActivities ? allActivities : [];
    let filteredTags = showTags
      ? getStateData(controller.state, "tags", [], "name")
      : [];

    if (!showArchived) {
      filteredActivities = filteredActivities.filter((a) => a.is_active);
    }

    if (!showFavorites) {
      filteredActivities = filteredActivities.filter((a) => a.is_favorite != 1);
    }

    let filteredSets = allSets;

    // Multi terms search
    if (term) {
      const pattern = Utils.getSearchPattern(term);

      // SETS
      //filteredSets = filteredSets.filter((a) => {
      //  return a.name && a.name.match(pattern);
      //});

      // TAGS
      filteredTags = filteredTags.filter((a) => {
        return a.name && a.name.match(pattern);
      });

      const tagIds = filteredTags.map((t) => t.id);

      // ACTVITIES: filter by name or by tags
      filteredActivities = filteredActivities.filter((a) => {
        return (
          (a.name && a.name.match(pattern)) ||
          (a.tags &&
            a.tags.filter((t) => {
              return tagIds.includes(t);
            }).length)
        );
      });
    }

    // Filter by sets
    if (hasItems(sets)) {
      filteredActivities = filteredActivities.filter((a) => {
        if (!a.sets) return false;

        // Check if activity sets contains any selected set id
        const activitySets = a.sets.filter((setId) => sets.includes(setId));
        return hasItems(activitySets);
      });
    }

    setIsLoading(false);
    setActivities(filteredActivities);
    //setVisibleSets(filteredSets);
    //setAllTags(filteredTags);
  };

  // ------------------------------------- ELEMENTS -------------------------------------
  const updateSelectedActivities = (activity, is_selected) => {
    if (is_selected) {
      selectedActivities.add(activity);
    } else {
      selectedActivities.delete(activity);
    }

    setSelectedActivities(selectedActivities);
  };

  const updateSelectedSets = ({ sets }) => {
    setSelectedSets([...selectedSets, sets]);
  };

  const onRemoveTag = (tag) => {
    const notSelected = selectedTags.filter((t) => t.id != tag.id);

    setAllTags([
      {
        ...tag,
        isSelected: false,
      },
      ...allTags,
    ]);

    setSelectedTags([...notSelected]);
  };

  const onSelectTag = (tag) => {
    const remainingTags = allTags.filter((t) => t.id != tag.id);
    setAllTags(remainingTags);
    setSelectedTags([
      ...selectedTags,
      {
        ...tag,
        isSelected: true,
      },
    ]);
  };

  const addActivity = () => {
    controller.changePage("feed", {
      selectedPage: "rn:edit_activity",
      args: {
        activity: getActivityModel(),
        returnUrl: "rn:onboarding_template",
      },
    });
  };

  const addTag = () => {
    controller.changePage("feed", {
      selectedPage: "rn:edit_tag",
      args: {
        tag: getTagModel({}),
        returnUrl: "rn:onboarding_template",
      },
    });
  };

  // ------------------------------------- UPDATE -------------------------------------
  const confirmElements = () => {
    const confirmedActivities = [...selectedActivities].map((a) => {
      return {
        ...a,
        hours: a.hours + 0,
        total_hours: a.total_hours + 0,
        id_activity: a.id,
      };
    });
    goBack({ activities: confirmedActivities });
  };

  // ------------------------------------- TUTORIALS -------------------------------------
  const initTutorials = () => {
    const isTutorialMode = (controller?.state?.showTutorials || {})[
      TutorialsHelper.STORAGE_KEYS.reflection
    ];

    setShowTutorials(isTutorialMode);

    if (isTutorialMode) {
      const tutorial = TUTORIALS_DATA["average_week"][6];
      setMariMessage(tutorial.message);
    } else {
      setMariMessage("");
    }
  };

  return (
    <KeyboardAvoidingView style={appStyles.container} behavior="height">
      <LastWeekHeader
        title="Edit Elements"
        subTitle="Choose tags, activities, and groups that are relevant to you."
        isLoading={isLoading}
        goBack={confirmElements}
        highlightBack={showTutorials}
        style={{
          minHeight: isWeb ? 80 : 110,
        }}
      />

      <LoadingIndicator isLoading={isLoading} />

      <ScrollView
        style={appStyles.scrollView}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        {/* {hasItems(selectedTags) ? (
          <TagsList
            title="Add Tags"
            tags={selectedTags}
            hideCollapse
            showRemove
            onRemoveTag={onRemoveTag}
            initialNumToRender={5}
          />
        ) : null} */}

        {hasItems(allTags) ? (
          <TagsList
            tags={allTags}
            onSelectTag={onSelectTag}
            initialNumToRender={AppConfig.NUM_OF_TAGS}
          />
        ) : null}

        {hasItems(activities) ? (
          <ActivitiesList
            contentType="activities"
            activities={activities}
            initialNumToRender={showAllActivities ? activities.length : 10}
            controller={controller}
            onActivitySelected={updateSelectedActivities}
            showSelector
          />
        ) : null}

        {/* {hasItems(visibleSets) ? (
          <ActivitiesSets
            title="Groups"
            sets={visibleSets}
            callback={updateSelectedSets}
            hideCollapse
            initialNumToRender={4}
          />
        ) : null} */}
      </ScrollView>

      <ElementsFabButton
        addActivity={addActivity}
        addTag={addTag}
        mariOptions={{ mariMessage: mariMessage, showTutorials }}
      />

      <Search
        filterResults={filterResults}
        placeholder="Search Elements"
        controller={controller}
      />
    </KeyboardAvoidingView>
  );
}
